export default __webpack_public_path__ + "static/bg-abandoned-robot--mobile-71bde46d10e9fa74f2b76f4c38c9d48f.webp";